<template>
  <div class="useCarApplyContainer">
    <div v-if="!isShowMap" style="width: 100%">
      <van-cell-group>
        <div class="typeContainer">
          <!-- <div class="labelTitle titleBGColor">
            {{ carInfo.applyTitle }}的用车申请
          </div> -->
          <van-cell-group>
            <van-field
              v-model="carInfo.applyTitle"
              class="labelTitle titleBGColor"
              :readonly="isShowUserId !== 'true'"
            />
          </van-cell-group>
        </div>
      </van-cell-group>
      <div class="useCarApplyContent">
        <van-form ref="form">
          <van-cell-group v-if="isShowUserId == 'true' || carInfo.leaderCode">
            <van-field
              v-model="carInfo.leaderCode"
              label="工号"
              placeholder="请输入工号"
              :rules="[{ required: true }]"
              @change="queryUserName"
            />
          </van-cell-group>
          <van-cell-group v-if="carInfo.leaderCode">
            <van-field
              v-model="carInfo.leaderName"
              label="姓名"
              placeholder="姓名"
              readonly
            />
          </van-cell-group>
          <van-cell-group v-if="carInfo.leaderCode">
            <van-field
              v-model="carInfo.deptName"
              label="部门"
              placeholder="部门"
              readonly
            />
          </van-cell-group>
          <van-cell-group>
            <div class="typeContainer">
              <div class="labelTitle">用车类型</div>
              <div class="useCarType">
                <div
                  class="typeItems"
                  :class="
                    carInfo.useType === index + 1 ? 'typeItemsActive' : ''
                  "
                  v-for="(item, index) in columns"
                  :key="index"
                  @click="selectUseType(item, index + 1)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="carInfo.useCost"
              label="用车成本中心"
              placeholder="请输入用车成本中心"
            />
            <div class="hintContent">
              <span>*</span>
              注意：用车的成本中心号需要填写惠州雷士光电科技的成本中心号
            </div>
          </van-cell-group>
          <van-cell-group v-if="carInfo.useType == 2 || carInfo.useType == 3">
            <van-field
              v-model="carInfo.flightInfo"
              label="航班信息"
              placeholder="请输入航班信息"
            />
          </van-cell-group>

          <van-cell-group v-if="carInfo.useType == 2 || carInfo.useType == 3">
            <van-field
              @click="showArriveTime"
              readonly
              :rules="[{ required: true }]"
              v-model="carInfo.expectArrivalTime"
              label="预计送达时间"
              placeholder="请输入预计送达时间"
            />
            <van-popup v-model="showArriveDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="选择年月日"
                :min-date="minDate"
                @confirm="comfirmArriveTime"
                @cancel="showArriveDate = false"
              />
            </van-popup>
          </van-cell-group>

          <van-cell-group>
            <van-field
              @click="showSaterTime"
              readonly
              :rules="[{ required: true }]"
              v-model="carInfo.useSaterTime"
              label="预估开始使用时间"
              placeholder="请输入预估车辆开始使用时间"
            />
            <van-popup v-model="showSaterDate" position="bottom">
              <van-datetime-picker
                v-model="sateDate"
                type="datetime"
                title="选择年月日"
                :min-date="minDate"
                @confirm="comfirmStare"
                @cancel="showSaterDate = false"
              />
            </van-popup>
          </van-cell-group>

          <van-cell-group>
            <van-field
              @click="showEndTime"
              readonly
              :rules="[{ required: true }, end()]"
              v-model="carInfo.useEndTime"
              label="预估结束使用时间"
              placeholder="请输入预估车辆结束使用时间"
            />
            <van-popup v-model="showEndDate" position="bottom">
              <van-datetime-picker
                v-model="endDate"
                type="datetime"
                title="选择年月日"
                :min-date="minDate"
                @confirm="comfirmEnd"
                @cancel="showEndDate = false"
              />
            </van-popup>
          </van-cell-group>
          <!-- @blur="onBlurairportName" -->
          <van-cell-group>
            <van-field
              :rules="[{ required: true }]"
              v-model="carInfo.airportName"
              :label="
                carInfo.useType == 2
                  ? '起点'
                  : carInfo.useType == 3
                  ? '起点'
                  : '起点'
              "
              :placeholder="
                carInfo.useType == 2
                  ? '请输入起点'
                  : carInfo.useType == 3
                  ? '请输入起点'
                  : '请输入起始地点详细信息'
              "
              class="my-field"
            >
              <template #button>
                <i
                  style="font-size: 24px; color: #4ea27c"
                  class="iconfont icon-mapmarker"
                ></i>
              </template>
            </van-field>
          </van-cell-group>

          <van-cell-group>
            <van-field
              @click="topathwayPlace"
              :rules="[{ required: true }]"
              v-model="carInfo.pathwayPlace"
              label="终点"
              readonly
              class="my-field"
              placeholder="请输入终点"
            >
              <template #button>
                <i
                  style="font-size: 24px; color: #4ea27c"
                  class="iconfont icon-mapmarker"
                ></i>
              </template>
            </van-field>
          </van-cell-group>

          <!-- <van-cell-group>
            <van-field @blur="onBlurdestination" :rules="[{ required: true }]" v-model="carInfo.destination" label="终点"
              placeholder="请输入终点详细信息" class="endPlace">
              <template #button>
                <i @click.stop="iconClick('终点')" style="font-size: 24px; color: #4ea27c"
                  class="iconfont icon-mapmarker"></i>
              </template>
            </van-field>
          </van-cell-group> -->

          <van-cell-group>
            <van-field
              v-model="carInfo.reason"
              rows="3"
              :rules="[{ required: true }]"
              autosize
              label="用车事由"
              type="textarea"
              placeholder="请输入用车事由"
            />
          </van-cell-group>

          <van-cell-group>
            <van-field
              @click="showUsepropleNum"
              readonly
              :rules="[{ required: true }]"
              v-model="carInfo.useNumber"
              label="用车人数"
              placeholder="请选择"
            >
              <template #button>
                <van-icon name="arrow-down" />
              </template>
            </van-field>
            <van-popup v-model="showUsepropleNumSelect" position="bottom">
              <van-picker
                show-toolbar
                :columns="useNumber"
                @confirm="confirmUsePropleNum"
                @cancel="cancelUsePropleNum"
              />
            </van-popup>
          </van-cell-group>

          <van-cell-group class="carRadio" v-if="zoneId != 1">
            <van-field name="radio" label="是否需要司机">
              <template #input>
                <van-radio-group
                  v-model="carInfo.driverType"
                  direction="horizontal"
                >
                  <van-radio name="1">是</van-radio>
                  <van-radio name="2">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </van-cell-group>

          <van-cell-group>
            <van-field
              :rules="[{ required: true }]"
              v-model="carInfo.useName"
              label="联系人"
              placeholder="请输入联系人姓名"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              :rules="[{ required: true }, tel]"
              v-model="carInfo.usePhone"
              label="联系人电话"
              placeholder="请输入联系人电话"
            >
              <template #button>
                <a :href="'tel:' + carInfo.usePhone" style="color: #4ea27c">
                  <i
                    style="font-size: 0.6rem"
                    class="iconfont icon-telephone"
                  ></i>
                </a>
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="carInfo.remarks"
              rows="3"
              autosize
              label="备注（随车物品）"
              type="textarea"
              placeholder="请输入备注"
            />
          </van-cell-group>

          <van-cell-group
            v-show="carInfo.applyNumber && carInfo.approveList.length > 0"
          >
            <div class="flowPath">
              <div class="flowPathTitle">审批流</div>
              <div>
                <!-- <div class="handle" style="display: flex">
                  <div class="handle-div">
                    <img
                      src="../../../../assets/car/handle.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                  <div style="margin-left: 10px">
                    <h3 style="margin: 5px 0; font-size: 16px">处理人</h3>
                    <div>
                      <span
                        v-for="(i, index) in carInfo.approveList"
                        :key="index"
                        class="clr-span"
                        >{{ i.approveName }}</span
                      >
                    </div>
                  </div>
                </div> -->
                <div class="container_item">
                  <div>
                    <div
                      class="handle"
                      v-for="(approve, index) in carInfo.approveList"
                      :key="approve.id"
                    >
                      <div class="handleDiv">
                        <img
                          src="@/assets/car/handle.png"
                          alt=""
                          srcset=""
                          style="width: 27px; height: 27px"
                        />
                      </div>
                      <div class="handleRight">
                        <h3 class="rightTitle" v-if="approve.nodeName">
                          {{ approve.nodeName }}
                        </h3>
                        <h3 class="rightTitle" v-if="!approve.nodeName">
                          {{ index == 0 ? "直属上级审批" : "审批人" }}
                          <!-- {{ approve.nodeName }} -->
                        </h3>
                        <div class="approver">
                          <div class="approverImg">
                            <!-- <div class="iconWrapper"> -->
                            <!-- <img :src="approve.icon" alt="" srcset="" style="width: 27px; height: 27px" /> -->
                            <!-- <span class="elIcon">
                                <i v-if="approve.approveState == '2'" class="el-icon-success" style="color: #267ef0"></i>
                                <i v-if="approve.approveState == '3'" class="el-icon-error" style="color: red"></i>
                              </span> -->
                            <!-- </div> -->

                            <span class="clr-span">{{
                              approve.approveName
                            }}</span>
                          </div>
                          <div class="right">
                            <span
                              style="margin-right: 5px"
                              :style="{
                                color:
                                  approve.approveState == '通过'
                                    ? '#267ef0'
                                    : approve.approveState == '驳回'
                                    ? 'red'
                                    : '',
                              }"
                              v-if="approve.nodeName"
                              >{{ approve.approveState }}</span
                            >
                            <span
                              style="margin-right: 5px"
                              :style="{
                                color:
                                  approve.approveState == '2'
                                    ? '#267ef0'
                                    : approve.approveState == '3'
                                    ? 'red'
                                    : '',
                              }"
                              v-if="!approve.nodeName"
                            >
                              {{
                                approve.approveState == "2"
                                  ? "已同意"
                                  : approve.approveState == "3"
                                  ? "已拒绝"
                                  : ""
                              }}
                              <!-- {{ approve.approveState }} -->
                            </span>
                            <span>{{ approve.approveTime }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-cell-group>
        </van-form>
      </div>
      <div class="footerBtn">
        <div>
          <van-button
            @click="cancel"
            type="default"
            size="small"
            style="width: 30%"
            >取消</van-button
          >
          <van-button
            :disabled="btnloading"
            type="info"
            size="small"
            @click="confirm"
            style="width: 70%; background-color: #4ea27c"
            >确定</van-button
          >
        </div>
      </div>
    </div>
    <!-- 地图 -->
    <!-- <div v-if="isShowMap">
      <div v-loading="loading" id="container" style="width: 100%; height: 80vh"></div>
      <div style="position: relative">
        <div class="circle" @click="ready">
          <i style="font-size: 0.7rem" class="iconfont icon-shuaxin"></i>
        </div>
        <div style="font-size: 16px">
          当前选中地址：{{ nowAddressobj.useLocation }}
        </div>
        <van-button style="width: 50%" @click="closeMap" type="default">取消</van-button>
        <van-button style="width: 50%" @click="determineMap" type="info">确认</van-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import "@/assets/car/icon/iconfont.css";
// import AMapLoader from "@amap/amap-jsapi-loader";
// window._AMapSecurityConfig = {
//   securityJsCode: "d7dd8082c27cd068108a8e1b6aed837f"
// };
import moment from "moment";
import "moment/locale/zh-cn";
import "@/assets/car/icon/iconfont.css";
import apis from "@/apis/car.js";
import api from "@/apis";
// const asyncJS = src => {
//   var jsapi = document.createElement("script");
//   jsapi.charset = "utf-8";
//   jsapi.src = src;
//   document.head.appendChild(jsapi);
// };
// import coordtransform from "coordtransform";
export default {
  name: "appointmentCarApply",
  data() {
    return {
      tel: {
        // 自定义校验规则
        validator: (value) => {
          console.log("value", value);
          return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57]|199)[0-9]{8}$/.test(
            value
          );
        },
        message: "请输入正确格式的手机号码",
        trigger: "onBlur",
      },
      activeNames: ["1"],
      carInfo: {
        applyTitle:
          this.$store.state.userInfo.department +
          "-" +
          this.$store.state.userInfo.nickname,
        useType: 1, //用车类型  1,"客户接待" 2,"接机送机" 3,"供应商考虑" 4,"其他"
        useCost: this.$store.state.userInfo.costCenterNo, //用车成本中心
        flightInfo: "", //航班信息
        expectArrivalTime: "", //预计到达时间
        time: "", //预计到达时间
        useSaterTime: "", //使用开始时间
        saterTime: "", //使用开始时间
        useEndTime: "", //使用结束时间
        endTime: "", //使用结束时间
        airportName: "惠州雷士光电科技有限公司", //起点
        pathwayPlace: "", //途径点
        // destination: "惠州雷士工业园", //目的地
        destination: "", //目的地
        useNumber: "", //用车人数
        driverType: "1",
        useName: this.$store.state.userInfo.nickname, //联系人
        createUser: this.$store.state.userInfo.userid, //申请人工号
        usePhone: this.$store.state.userInfo.phone, //电话
        remarks: "", //备注
        addressInfoList: [], //地址集合
        applyDeptName: this.$store.state.userInfo.department, //部门名称
        airportNameList: [
          {
            useLocation: "惠州雷士光电科技有限公司",
            longitude: 114.469533,
            dimension: 23.197486,
          },
        ], //起点集合
        destinationList: [
          // {
          //   useLocation: "惠州雷士工业园",
          //   longitude: 114.469532,
          //   dimension: 23.197495
          // }
        ], //终点集合
        approveList: [],
        leaderCode: null, //领导工号
        leaderName: "", //领导姓名
        deptName: "", //领导部门
        reason: "", // 用车事由
      },
      useSaterTime: "",
      useEndTime: "",
      minDate: new Date(),
      currentDate: new Date(),
      sateDate: new Date(),
      endDate: new Date(),
      showUseTypeSelect: false,
      showUsepropleNumSelect: false,
      showArriveDate: false,
      showSaterDate: false,
      showEndDate: false,
      columns: ["客户接待", "接机", "送机", "供应商考察", "其他"],
      useNumber: ["1", "2", "3", "4", "5", "6"],
      btnloading: false,
      map: null,
      mapMark: null,
      longAndLat: "",
      isShowMap: false,
      nowAddressobj: "",
      iconClickTitle: "",
      loading: true,
      isShowUserId: null,
      carInfoDetails: {},
      zoneId: "",
    };
  },
  created() {
    const carInfo = sessionStorage.getItem("carInfo");
    if (carInfo) {
      this.carInfo = JSON.parse(carInfo);
      // if (
      //   this.carInfo.airportName
      // ) {
      //   this.search("起点");
      // }
      // if (
      //   this.carInfo.destination
      // ) {
      //   this.search("终点");
      // }
    }
    let addressInfoList = sessionStorage.getItem("addressInfoList")
      ? JSON.parse(sessionStorage.getItem("addressInfoList"))
      : [];
    let pathwayPlace = [];
    if (addressInfoList.length > 0) {
      addressInfoList.filter((item) => {
        pathwayPlace.push(item.useLocation);
      });
    }
    this.carInfo.pathwayPlace = pathwayPlace.toString(); //显示途径地名称
    this.carInfo.addressInfoList = addressInfoList;
  },
  mounted() {
    this.isShowUserId = this.$route.query.isShowUserId;
    sessionStorage.removeItem("carInfo");
    let applyNumber = this.$route.query.applyNumber;
    applyNumber ? this.postqueryUseCarDetails(applyNumber) : "";
    this.zoneId = localStorage.getItem("cityId");
    if (this.zoneId == "1") {
      this.carInfo.airportName = "惠州雷士光电科技有限公司";
    } else if (this.zoneId == "2") {
      this.carInfo.airportName = "中山雷士灯饰科技有限公司";
    } else if (this.zoneId == "3") {
      this.carInfo.airportName = "重庆市万州区申明北路168号";
    } else {
      this.carInfo.airportName = "惠州雷士光电科技有限公司";
    }
    if(this.$route.query.minDate == 'true'){
      // 获取当前日期的前七天
      this.minDate = new Date();
      this.minDate.setDate(this.minDate.getDate() - 7);
    }
    // asyncJS(
    //   "https://webapi.amap.com/maps?v=1.4.15&key=db734ee0deb249082595ed2fb6f74750&callback=onLoadMap"
    // );
  },

  methods: {
    // ready() {
    //   this.map = new window.AMap.Map("container", {
    //     resizeEnable: true,
    //     zoom: 17 // 将缩放级别设置为17
    //   });

    //   let _this = this;

    //   // 获取当前位置和地址名称
    //   window.AMap.plugin("AMap.Geolocation", () => {
    //     console.log("00000");
    //     let geolocation = new window.AMap.Geolocation({
    //       enableHighAccuracy: true,
    //       timeout: 10000
    //     });
    //     geolocation.getCurrentPosition((status, result) => {
    //       if (status === "complete") {
    //         let lng = result.position.lng;
    //         let lat = result.position.lat;

    //         _this.longAndLat = lng + "," + lat;

    //         // 在地图上标注当前位置
    //         _this.map.clearMap();

    //         let mapMarker = new window.AMap.Marker({
    //           position: [lng, lat],
    //           map: _this.map
    //         });

    //         _this.map.setCenter(mapMarker.getPosition());
    //         _this.map.setZoom(17); // 将缩放级别设置为17
    //         mapMarker.setMap(_this.map);

    //         // 获取当前地址名称
    //         window.AMap.plugin("AMap.Geocoder", () => {
    //           let geocoder = new window.AMap.Geocoder();

    //           geocoder.getAddress([lng, lat], (status, result) => {
    //             if (status === "complete" && result.info === "OK") {
    //               let address = result.regeocode.formattedAddress;
    //               console.log("当前位置地址：", address, lng, lat);
    //               // 在这里将地址名称赋值给你的变量或进行其他操作
    //               _this.nowAddressobj = {
    //                 useLocation: address,
    //                 longitude: lng,
    //                 dimension: lat
    //               };
    //               this.loading = false;
    //             } else {
    //               // console.log('获取当前位置地址失败');
    //               _this.$toast("获取当前位置地址失败");
    //               _this.nowAddressobj = {};
    //               this.loading = false;
    //             }
    //           });
    //         });
    //       } else {
    //         _this.$toast("获取当前位置失败，请手动点击地图选择");
    //         _this.nowAddressobj = {};
    //         console.log("111");
    //         this.loading = false;
    //       }
    //     });
    //   });

    //   this.map.on("click", e => {
    //     let lng = e.lnglat.getLng();
    //     let lat = e.lnglat.getLat();
    //     _this.longAndLat = lng + "," + lat;

    //     // 打新的标记
    //     _this.map.clearMap();

    //     let mapMarker = new window.AMap.Marker({
    //       position: [lng, lat],
    //       map: _this.map
    //     });

    //     _this.map.setCenter(mapMarker.getPosition());
    //     _this.map.setZoom(17); // 将缩放级别设置为17
    //     mapMarker.setMap(_this.map);

    //     // 获取点击位置的地址名称
    //     window.AMap.plugin("AMap.Geocoder", () => {
    //       let geocoder = new window.AMap.Geocoder();

    //       geocoder.getAddress([lng, lat], (status, result) => {
    //         if (status === "complete" && result.info === "OK") {
    //           let address = result.regeocode.formattedAddress;
    //           console.log("点击位置地址：", address, lng, lat);
    //           _this.nowAddressobj = {
    //             useLocation: address,
    //             longitude: lng,
    //             dimension: lat
    //           };
    //           console.log(
    //             "国测局坐标转百度经纬度坐标",
    //             coordtransform.gcj02tobd09(lng, lat)
    //           );
    //           // 在这里将地址名称赋值给你的变量或进行其他操作
    //         } else {
    //           console.log("获取点击位置地址失败");
    //           _this.nowAddressobj = {};
    //         }
    //       });
    //     });
    //   });
    // },
    //判断结算时间是否小于开始时间
    end() {
      let saterTime = this.carInfo.saterTime;
      let endTime = this.carInfo.endTime;
      console.log(new Date(saterTime).getTime() > new Date(endTime));
      return {
        validator: () => {
          return saterTime
            ? new Date(saterTime).getTime() < new Date(endTime).getTime()
            : true;
        },
        message: "结算时间不能小于开始时间",
        trigger: "onBlur",
      };
    },
    //起点失去焦点
    // async onBlurairportName() {
    //   if (this.carInfo.airportName) {
    //     await this.search("起点");
    //   }
    // },
    //终点失去焦点
    // async onBlurdestination() {
    //   if (this.carInfo.destination) {
    //     await this.search("终点");
    //   }
    // },
    //显示人数选择
    showUsepropleNum() {
      this.showUsepropleNumSelect = true;
    },
    //人数选择确定
    confirmUsePropleNum(value) {
      this.carInfo.useNumber = value;
      this.showUsepropleNumSelect = false;
    },
    // 人数选择取消
    cancelUsePropleNum() {
      this.showUsepropleNumSelect = false;
    },
    //选择用车类型
    selectUseType(item, index) {
      this.carInfo.useType = index;
    },
    // 途径点
    topathwayPlace() {
      sessionStorage.setItem("carInfo", JSON.stringify(this.carInfo));
      sessionStorage.setItem("isShowUserId", this.isShowUserId);
      this.$router.replace({
        path: "/car/official/pathwayPlace",
        query: {
          keyName: "official",
          name: "appointmentCarApply",
        },
      });
    },
    //显示 预计到达时间
    showArriveTime() {
      this.showArriveDate = true;
    },
    //显示开始时间
    showSaterTime() {
      this.showSaterDate = true;
    },
    //显示结束时间
    showEndTime() {
      this.showEndDate = true;
    },
    // 确定 时间
    comfirmArriveTime(value) {
      console.log("预计", value);
      this.carInfo.time = value;
      this.carInfo.expectArrivalTime = moment(value).format(
        "YY年MM月DD日 dddd HH:mm"
      );
      this.showArriveDate = false;
    },
    //确认开始时间
    comfirmStare(value) {
      console.log("开始", value);
      this.carInfo.saterTime = value;
      this.carInfo.useSaterTime = moment(value).format("MM月DD日 dddd HH:mm");
      this.showSaterDate = false;
    },
    //确认结束时间
    comfirmEnd(value) {
      console.log("结束", value);
      this.carInfo.endTime = value;
      this.carInfo.useEndTime = moment(value).format("MM月DD日 dddd HH:mm");
      this.showEndDate = false;
    },
    //取消
    cancel() {
      this.btnloading = false;
      // this.$router.replace({ path: "/car/official/index" })
      this.$router.go(-1);
    },
    //确认
    confirm() {
      this.$refs.form
        .validate()
        .then(() => {
          this.btnloading = true;
          // if (this.carInfo.airportNameList.length == 0)
          //   return this.$toast.fail(
          //     "您填写的" + this.carInfo.useType == 2
          //       ? "接机机场名称"
          //       : this.carInfo.useType == 3
          //         ? "送机机场名称"
          //         : "起点" + "有问题，请检查"
          //   );
          this.postinsertApplyCar();
        })
        .catch((e) => {
          console.log("e", e);
          this.btnloading = false;
          this.$toast.fail("提交失败");
        });
    },
    // search(val) {
    //   let _this = this;
    //   val == "起点"
    //     ? (this.carInfo.airportNameList = [])
    //     : (this.carInfo.destinationList = []);
    //   window.AMap.plugin("AMap.PlaceSearch", () => {
    //     var autoOptions = {
    //       city: "全国",
    //       map: _this.map, // 展现结果的地图实例
    //       pageSize: 1, // 单页显示结果条数
    //       pageIndex: 1, // 页码
    //       autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
    //     };
    //     var placeSearch = new window.AMap.PlaceSearch(autoOptions);
    //     placeSearch.search(
    //       val == "起点" ? this.carInfo.airportName : this.carInfo.destination,
    //       (status, result) => {
    //         console.log('status', status);
    //         // 搜索成功时，result即是对应的匹配数据
    //         if (status == "complete") {
    //           if (result.poiList.pois.length > 0) {
    //             let lng = result.poiList.pois[0].location.lng;
    //             let lat = result.poiList.pois[0].location.lat;
    //             _this.longAndLat = lng + "," + lat;
    //             console.log(val, lng + "," + lat);
    //             console.log(
    //               "国测局坐标转百度经纬度坐标",
    //               coordtransform.gcj02tobd09(lng, lat)
    //             );
    //             val == "起点"
    //               ? this.carInfo.airportNameList.push({
    //                 useLocation:
    //                   val == "起点"
    //                     ? this.carInfo.airportName
    //                     : this.carInfo.destination,
    //                 longitude: lng,
    //                 dimension: lat
    //               })
    //               : this.carInfo.destinationList.push({
    //                 useLocation:
    //                   val == "起点"
    //                     ? this.carInfo.airportName
    //                     : this.carInfo.destination,
    //                 longitude: lng,
    //                 dimension: lat
    //               });
    //           } else {
    //             this.$toast("没有查询到对应的地址");
    //             val == "起点"
    //               ? (this.carInfo.airportName = "")
    //               : (this.carInfo.destination = "");
    //           }
    //         } else if (status == "no_data") {
    //           this.$toast("没有查询到对应的地址");
    //           val == "起点"
    //             ? (this.carInfo.airportName = "")
    //             : (this.carInfo.destination = "");
    //         } else if (status == "error") {
    //           this.$toast("高德地图获取地址失败！");
    //           val == "起点"
    //             ? (this.carInfo.airportName = "")
    //             : (this.carInfo.destination = "");
    //         } else {
    //           this.$toast("免费额度已用完，请购买高德地图api");
    //           val == "起点"
    //             ? (this.carInfo.airportName = "")
    //             : (this.carInfo.destination = "");
    //         }
    //       }
    //     );
    //   });
    // },
    //获取地址经纬度
    // initMap(val) {
    //   return new Promise((resolve, reject) => {
    //     val == "起点"
    //       ? (this.carInfo.airportNameList = [])
    //       : (this.carInfo.destinationList = []);
    //     AMapLoader.reset();
    //     AMapLoader.load({
    //       key: "db734ee0deb249082595ed2fb6f74750", // 申请好的Web端开发者Key，首次调用 load 时必填
    //       version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    //       plugins: [
    //         "AMap.AutoComplete",
    //         "AMap.PlaceSearch",
    //         "AMap.Geolocation",
    //         "AMap.Geocoder",
    //         "AMap.CitySearch"
    //       ] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    //     })
    //       .then(AMap => {
    //         var geocoder = new AMap.Geocoder({
    //           city: "全国"
    //         });
    //         // 根据城市获取经纬度
    //         geocoder.getLocation(
    //           val == "起点"
    //             ? this.carInfo.airportName
    //             : this.carInfo.destination,
    //           (status, result2) => {
    //             console.log("根据城市获取经纬度", status, result2);
    //             if (status === "complete" && result2.geocodes.length) {
    //               val == "起点"
    //                 ? this.carInfo.airportNameList.push({
    //                   useLocation:
    //                     val == "起点"
    //                       ? this.carInfo.airportName
    //                       : this.carInfo.destination,
    //                   longitude: result2.geocodes[0].location.lng,
    //                   dimension: result2.geocodes[0].location.lat
    //                 })
    //                 : this.carInfo.destinationList.push({
    //                   useLocation:
    //                     val == "起点"
    //                       ? this.carInfo.airportName
    //                       : this.carInfo.destination,
    //                   longitude: result2.geocodes[0].location.lng,
    //                   dimension: result2.geocodes[0].location.lat
    //                 });
    //               resolve(
    //                 val == "起点"
    //                   ? this.carInfo.airportNameList
    //                   : this.carInfo.destinationList
    //               );
    //             } else {
    //               reject(new Error("获取经纬度失败"));
    //             }
    //           }
    //         );
    //       })
    //       .catch(e => {
    //         console.log("error", e);
    //       });
    //   });
    // },
    // 根据工号获取姓名
    queryUserName() {
      api
        .queryByUsername({ username: this.carInfo.leaderCode })
        .then((res) => {
          if (res.code == 200) {
            this.carInfo.leaderName = res.data.nickname;
            this.carInfo.deptName = res.data.department;
            this.carInfo.useName = res.data.nickname;
            this.carInfo.usePhone = res.data.phone;
          }
        })
        .catch(() => {
          this.$toast.fail("请输入正确工号");
        });
    },

    //发送申请接口
    postinsertApplyCar() {
      let applyNumber = this.carInfo.applyNumber;
      // let addressInfoList = [].concat(
      //   this.carInfo.airportNameList,
      //   this.carInfo.addressInfoList,
      //   this.carInfo.destinationList
      // );
      let obj = {};
      applyNumber
        ? (obj = {
            useType: this.carInfo.useType,
            applyTitle: this.carInfo.applyTitle,
            useCost: this.carInfo.useCost,
            flightInfo:
              this.carInfo.useType == "2" || this.carInfo.useType == "3"
                ? this.carInfo.flightInfo
                : "",
            expectArrivalTime:
              this.carInfo.useType == "2" || this.carInfo.useType == "3"
                ? moment(this.carInfo.time).format("YYYY-MM-DD HH:mm:ss")
                : "",
            useSaterTime: moment(this.carInfo.saterTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            useEndTime: moment(this.carInfo.endTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            airportName: this.carInfo.airportName,
            // destination: this.carInfo.destination,
            useNumber: this.carInfo.useNumber,
            useName: this.carInfo.useName,
            createUser: this.carInfo.createUser,
            usePhone: this.carInfo.usePhone,
            remarks: this.carInfo.remarks,
            applyDeptName: this.carInfo.leaderCode
              ? this.carInfo.deptName
              : this.carInfo.applyDeptName,
            addressInfoList: this.carInfo.addressInfoList,
            applyNumber,
            id: this.carInfo.id,
            cityId: localStorage.getItem("cityId"),
            reason: this.carInfo.reason
            // driverType: this.carInfo.driverType
          })
        : (obj = {
            useType: this.carInfo.useType,
            applyTitle: this.carInfo.applyTitle,
            useCost: this.carInfo.useCost,
            flightInfo: this.carInfo.flightInfo,
            expectArrivalTime:
              this.carInfo.useType == "2"
                ? moment(this.carInfo.time).format("YYYY-MM-DD HH:mm:ss")
                : "",
            useSaterTime: moment(this.carInfo.saterTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            useEndTime: moment(this.carInfo.endTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            airportName: this.carInfo.airportName,
            // destination: this.carInfo.destination,
            useNumber: this.carInfo.useNumber,
            useName: this.carInfo.useName,
            createUser: this.carInfo.createUser,
            usePhone: this.carInfo.usePhone,
            remarks: this.carInfo.remarks,
            addressInfoList: this.carInfo.addressInfoList,
            applyDeptName: this.carInfo.leaderCode
              ? this.carInfo.deptName
              : this.carInfo.applyDeptName,
            cityId: localStorage.getItem("cityId"),
            reason: this.carInfo.reason
            // driverType: this.carInfo.driverType
          });
      if (this.zoneId != 1) {
        obj.driverType = this.carInfo.driverType;
      }
      if (this.carInfo.leaderCode) {
        obj.leaderCode = this.carInfo.leaderCode;
        obj.leaderName = this.carInfo.leaderName;
      }
      console.log("obj111", obj);

      if (applyNumber) {
        //修改
        apis
          .updateMyApplication(obj)
          .then((res) => {
            console.log("修改成功", res);
            if (res.code == "200" && res.message == "success") {
              this.$toast.success("修改成功");
              // this.$router.replace({ path: "/car/official/index" });

              this.$router.go(-1);
            } else {
              this.btnloading = false;
              this.$toast.fail(res.message);
            }
          })
          .catch(() => {
            // this.$toast.fail('提交失败')
            this.btnloading = false;
          });
      } else {
        //提交
        apis
          .insertApplyCar(obj)
          .then((res) => {
            console.log("提交成功", res);
            if (res.code == "200" && res.message == "success") {
              this.$toast.success("提交成功");
              // this.$router.replace({ path: "/car/official/index" });
              this.$router.go(-1);
            } else {
              this.$toast.fail(res.message);
              this.btnloading = false;
            }
          })
          .catch(() => {
            // this.$toast.fail('提交失败')
            this.btnloading = false;
          });
      }
    },

    //查看详情
    postqueryUseCarDetails(applyNumber) {
      this.carInfo.airportNameList = [];
      this.carInfo.destinationList = [];
      apis
        .queryUseCarDetails({ applyNumber })
        .then((res) => {
          console.log("查看详情", res.data);
          this.carInfoDetails = res.data;
          let carInfo = res.data;
          carInfo.time = carInfo.expectArrivalTime
            ? new Date(carInfo.expectArrivalTime)
            : new Date();
          carInfo.expectArrivalTime = moment(carInfo.time).format(
            "YY年MM月DD日 dddd HH:mm"
          );
          carInfo.saterTime = carInfo.useSaterTime;
          carInfo.useSaterTime = moment(carInfo.saterTime).format(
            "MM月DD日 dddd HH:mm"
          );
          carInfo.endTime = carInfo.useEndTime;
          carInfo.useEndTime = moment(carInfo.endTime).format(
            "MM月DD日 dddd HH:mm"
          );
          carInfo.applyNumber = this.$route.query.applyNumber; //存id
          this.minDate = new Date(carInfo.saterTime);
          this.currentDate = carInfo.time ? new Date(carInfo.time) : new Date();
          this.sateDate = carInfo.saterTime
            ? new Date(carInfo.saterTime)
            : new Date();
          this.endDate = carInfo.endTime
            ? new Date(carInfo.endTime)
            : new Date();
          if (carInfo.addressInfoList.length > 0) {
            // carInfo.airportNameList = [carInfo.addressInfoList.shift()];
            // carInfo.destinationList = [carInfo.addressInfoList.pop()];
            let addressInfoList = carInfo.addressInfoList;
            if (addressInfoList.length > 0) {
              sessionStorage.setItem(
                "addressInfoList",
                JSON.stringify(addressInfoList)
              );
            }

            let pathwayPlace = [];
            carInfo.addressInfoList.filter((item) => {
              pathwayPlace.push(item.useLocation);
            });
            carInfo.pathwayPlace = pathwayPlace.toString(); //显示途径地名称
          }
          this.carInfo = carInfo;
          this.carInfo.deptName = carInfo.applyDeptName;
        })
        .catch(() => {
          // this.$toast.fail('提交失败')
        });
    },
    //地址图标点击
    // iconClick(val) {
    //   console.log("iconClick", val);
    //   this.isShowMap = true;
    //   this.iconClickTitle = val;
    //   this.nowAddressobj = {};
    //   // key 值需要去高德地图去申请才可以
    //   asyncJS(
    //     "https://webapi.amap.com/maps?v=1.4.15&key=db734ee0deb249082595ed2fb6f74750&callback=onLoadMap"
    //   );
    //   this.$nextTick(() => {
    //     window.onLoadMap = () => {
    //       this.isShowMap ? this.ready() : '';
    //     };
    //   });
    // },

  //关闭地图
    closeMap() {
      this.isShowMap = false;
      this.loading = true;
    },
    //确认地图选择
    determineMap() {
      if (this.iconClickTitle == "起点") {
        this.carInfo.airportName = this.nowAddressobj.useLocation;
        this.carInfo.airportNameList = [this.nowAddressobj];
      } else if (this.iconClickTitle == "终点") {
        this.carInfo.destination = this.nowAddressobj.useLocation;
        this.carInfo.destinationList = [this.nowAddressobj];
      }

      this.isShowMap = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .useCarApplyContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .useCarApplyContainer {
    width: 276px * $zoom;
  }
}

.useCarApplyContainer {
  margin: auto;

  .titleBGColor {
    padding: 0 30px;
    font-size: 29px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #282b32;
    height: 80px;
    line-height: 80px;
    background-color: #f7f9fa;
  }

  ::v-deep .van-hairline--top-bottom::after {
    content: "";
    border: 0;
  }

  .useCarApplyContent {
    // width: 680px;
    padding: 0 30px;
    margin: auto;

    ::v-deep .van-cell__title {
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #282b32;
    }

    ::v-deep(.van-cell-group) {
      .typeContainer {
        // padding: 18px 0;

        .labelTitle {
          margin: 15px 0;
          font-size: 29px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
        }

        .useCarType {
          display: flex;
          margin-top: 10px;
          font-size: 26px;

          .typeItems {
            padding: 0 10px;
            // width: 160px;
            height: 54px;
            line-height: 54px;
            text-align: center;
            background: #f7f9fa;
            border-radius: 4px;
            margin-right: 20px;
            color: #969b9e;
          }

          .typeItemsActive {
            background-color: #4ea27c;
            color: #fff;
          }
        }
      }

      .van-cell {
        display: flex;
        flex-direction: column;
        padding: 18px 0;
      }

      .van-field__value {
        background-color: #f7f9fa;
        padding: 10px 20px;
      }

      .van-cell::after {
        content: "";
        border-bottom: 0;
      }

      .van-field__label {
        width: 500px !important;
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
        margin-bottom: 15px;
      }

      .endPlace .van-field__label::after {
        content: "（默认为公司，有需要可修改）";
        font-size: 16px;
        color: #b5b9bb;
      }
    }

    ::v-deep .van-hairline--top-bottom::after {
      content: "";
      border: 0;
    }

    .userName {
      font-size: 26px;
      padding: 20px 25px;
    }

    .hintContent {
      font-size: 18px;
      padding-bottom: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #969b9e;

      span {
        color: red;
      }
    }

    .flowPath {
      padding: 15px 0;

      .flowPathTitle {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
        margin-bottom: 20px;
      }
    }
  }

  .footerBtn {
    // padding-top: 30px;
    background-color: #f7f9fa;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }

  .handle {
    display: flex;

    .handle-div::after {
      display: block;
      content: "";
      width: 1px;
      height: 70px;
      background-color: #ccc;
      position: relative;
      left: 24px;
    }

    .handle-div {
      position: relative;
    }
  }

  .copy {
    display: flex;

    .copy-div {
      position: relative;
    }
  }

  .clr-span {
    display: inline-block;
    width: 160px;
    border-radius: 20px;
    background-color: rgb(248 250 251);
    margin: 0 5px;
    padding: 10px 0;
    font-size: 32px;
    text-align: center;
  }

  .circle {
    z-index: 2;
    width: 40px;
    height: 40px;
    border-radius: 100px;
    position: absolute;
    top: -200px;
    right: 2%;
    cursor: pointer;
    border-radius: 50%;
    // background-color: rgb(47, 116, 235);
    // animation: blink 5s linear infinite;
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}
.carRadio {
  ::v-deep {
    .van-cell__value {
      background: none !important;
    }
  }
}
.container_item {
  background: #fff;
  margin-top: 20px;
  padding: 25px;

  .title {
    color: rgba(150, 155, 158, 1);
    font-size: 30px;
  }

  .handle {
    display: flex;
    margin-top: 10px;

    &:last-child {
      .handleDiv::after {
        width: 0;
        height: 0;
      }
    }

    .handleDiv::after {
      display: block;
      content: "";
      width: 1px;
      height: 70px;
      background-color: #ccc;
      position: relative;
      left: 24px;
    }

    .handleRight {
      margin-left: 20px;
      width: calc(100vh);

      .rightTitle {
        margin: 10px 0;
        font-size: 29px;
      }

      .approver {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        .approverImg {
          display: flex;
          flex-shrink: 0;
          align-items: center;

          .iconWrapper {
            position: relative;

            .elIcon {
              position: absolute;
              left: 40px;
              top: -10px;
              font-size: 22px;
            }
          }

          .clr-span {
            display: inline-block;
            border-radius: 20px;
            background-color: rgb(248 250 251);
            margin: 0 5px;
            padding: 10px 0;
            font-size: 24px;
            text-align: center;
            margin-left: 15px;
          }
        }

        .right {
          flex-shrink: 0;
          // margin-left: 30%;
          font-size: 22px;
          color: #9fa2a5;
        }
      }
    }
  }
}
</style>
